import { render } from "./programme1.vue?vue&type=template&id=b112f82c&scoped=true"
import script from "./programme1.vue?vue&type=script&lang=js"
export * from "./programme1.vue?vue&type=script&lang=js"

import "./programme1.vue?vue&type=style&index=0&id=b112f82c&lang=less&scoped=true"

import exportComponent from "E:\\develop\\company\\gw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b112f82c"]])

export default __exports__